module.exports = __webpack_public_path__ + "resources/img/img_datahunt5_jp.45b31aa2d974902b99272da57bf8615d.png";